import { cubicEaseOut } from '@helpers/animate';
import fonts from '@helpers/fonts';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/image';
import { h6, paragraph } from '@helpers/typography';
import SimpleImage from '@stories/Components/SimpleImage/SimpleImage';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled(m.div) ``;
const VideoWrapper = styled.div `
  position: relative;
  height: 0;
  padding-bottom: ${(9 / 16) * 100}%;
  width: 100%;
`;
const ImageWrapper = styled.button `
  ${imageWrapperPreserveRatio(16, 9)}
  background: 0;
  border: 0;
  margin: 0;
  width: 100%;
`;
const Image = styled(SimpleImage) `
  ${imageCoverContainer()}
  transform: scale(1);
  transition: transform 1s ${cubicEaseOut};
  z-index: 1;

  ${ImageWrapper}:focus &,
  ${ImageWrapper}:hover & {
    transform: scale(1.1);
  }
`;
const Button = styled.span `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1);
  transition: transform 0.3s ${cubicEaseOut};
  z-index: 1;

  ${ImageWrapper}:focus &,
  ${ImageWrapper}:hover & {
    transform: translate(-50%, -50%) scale(1.2);
  }
`;
const TopContent = styled.div `
  display: flex;
  flex-direction: column;
`;
const Title = styled.h6 `
  ${h6}
  ${fonts.helvetica.medium}
`;
const Content = styled.p `
  ${paragraph}
`;
export const VideoEmbedBlockStyles = {
    Container,
    VideoWrapper,
    ImageWrapper,
    Image,
    Button,
    TopContent,
    Title,
    Content,
};
